import anime from 'animejs/lib/anime.es.js';

export const PXSolutions = (function () {
	'use strict';

	var $solutions,
		$imageOverlay,
		$images,
		winH,
		transformAmount,
		$links,
		isAnimating = false;

	function init() {
		return;
		$solutions = $('.pxblock--solutions');
		winH = $(window).height();

		if ($solutions) {
			$imageOverlay = $solutions.find('.images-overlay');
			$images = $solutions.find('.images-overlay__image');
			$links = $solutions.find('a');

			$('.pxblock--solutions').on('mousemove', trackMouse);
			$(window).on('resize', resize);

			$links.each(function (idx, item) {
				item.addEventListener('mouseover', (ev) => {
					$links.not(item).addClass('hover-sibling');
				});
				item.addEventListener('mouseout', (ev) => {
					$links.not(item).removeClass('hover-sibling');
				});
			});
		}
	}

	function trackMouse(e) {
		// if (isAnimating) return;

		var offset = e.clientY - winH / 2;
		transformAmount = Math.floor(offset * 0.5);

		anime({
			targets: '.images-overlay',
			translateY: transformAmount + 'px',
			easing: 'easeOutExpo',
			begin: (anim) => {
				isAnimating = true;
			},
			complete: (anim) => {
				isAnimating = false;
			},
		});

		// $imageOverlay.css({
		// 	transform: 'translateY(' + transformAmount + 'px)',
		// });
	}

	function resize(e) {
		winH = $(window).height();
	}

	return {
		init: init,
	};
})();
